import React from 'react';
import { motion } from 'framer-motion';
interface SectionRevealProps {
  children: ReactNode;
  className?: string;
  id?: string;
  bgColor?: 'white' | 'mint' | 'dark';
}
export function SectionReveal({
  children,
  className = '',
  id,
  bgColor = 'white'
}: SectionRevealProps) {
  const bgClasses = {
    white: 'bg-[#FAFAFA]',
    mint: 'bg-[#F0FDF4]',
    dark: 'bg-[#1A1A2E]'
  };
  return <section id={id} className={`py-20 md:py-32 overflow-hidden ${bgClasses[bgColor]} ${className}`} data-id="element-214">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-215">
        {children}
      </motion.div>
    </section>;
}